define.alias("shared/components/shared/page-picker-legacy", "preview-grid/components/shared/page-picker-legacy");